<template>
    <div class="page-transit clearfix">
        
    </div>
</template>
<script>
import DB from "@/common/db";
export default {
  name: "index-introduce",
  data() {
    return {
      accessToken: this.$route.query.accessToken
        ? this.$route.query.accessToken
        : "",
      userId: this.$route.query.userId ? this.$route.query.userId : "",
      url: this.$route.query.url || "/index.html#/"
    };
  },

  methods: {},
  components: {},
  created() {
    let url = this.$route.query.url || "/index.html#/";
    DB.request({
      url: DB.prefix + "auth/v2/crossLoginWithToken",
      type: "post",
      data: {
        accessToken: this.accessToken,
        userId: this.userId
      },
      showMessage: false,
      success: res => {},
      complete: () => {
        window.location.href = this.url;
      }
    });
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-transit {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/transit.vue